export default __webpack_public_path__ + "static/media/Like.843f6014.svg";